import { useContext } from 'react';

import { type CheckoutContextType, ClientSecretContext } from '../_components/ClientSecretContext';

const defaultContext: CheckoutContextType = {
  clientSecret: null,
  setClientSecret: () => {},
  redemptionToken: null,
  setRedemptionToken: () => {},
  showThankYou: false,
  setShowThankYou: () => {},
  showRedemptionModal: false,
  setShowRedemptionModal: () => {},
  redemptionState: 'loading',
  setRedemptionState: () => {},
  orderStatusData: null,
  setOrderStatusData: () => {},
  redemptionErrorMessage: null,
  setRedemptionErrorMessage: () => {},
  shouldInstantlyRedeem: false,
  showFreeProductCheckoutModal: false,
  setShowFreeProductCheckoutModal: () => {},
};

export function useClientSecretContext() {
  const context = useContext(ClientSecretContext);
  if (context === undefined) {
    return defaultContext;
  }
  return context;
}

/** Alias for useClientSecretContext */
export const useCheckoutContext = useClientSecretContext;
